import { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { showNotification } from "../../redux/actions/notification";
import CustomBadge from "../../common/CustomBadge";
import CustomPopConfirm from "../../common/CustomPopConfirm";
import ImageUploader from "./ImageUploader";
import { registerCrewMemberImageApi } from "../../apis/crewImage";
import ImagePreview from "./ImagePreview";

const ImageOption = ({ record, onImageUpdated }) => {
  const dispatch = useDispatch();
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);

  const handleUpload = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append("picture", file);
    const query = {
      employeeid: record?.employeeId,
    };

    try {
      await registerCrewMemberImageApi(query, formData);

      resetInput();
      dispatch(
        showNotification({
          type: "success",
          message: "Success",
          description: "User Image Added Successfully",
        })
      );

      onImageUpdated();

    } catch (error) {
      dispatch(
        showNotification({
          type: "error",
          message: "Failed to Add",
          description: error?.message,
        })
      );
    } finally {
      setFile(null);
    }
  };

  const resetInput = () => {
    setFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  const handleCancel = () => {
    resetInput();
    setFile(null);
  };

  return (
    <CustomPopConfirm
      title="Crew Members"
      content={
        record?.employeePhotos && record?.employeePhotos?.length > 0 ? (
          <ImagePreview employeePhotoId={record} onImageUpdated={onImageUpdated} />
        ) : (
          <ImageUploader file={file} setFile={setFile} />
        )
      }
      okText={
        record?.employeePhotos && record?.employeePhotos?.length > 0 ? "" : "Upload"
      }
      cancelText="Cancel"
      showCancel={true}
      onConfirm={handleUpload}
      onCancel={handleCancel}
      triggerElement={
        <CustomBadge
          status={
            record?.employeePhotos && record?.employeePhotos.length > 0
              ? "success"
              : "error"
          }
          icon={<span style={{ fontSize: "20px" }}>📸</span>}
        />
      }
    />
  );
};

export default ImageOption;
